import { LogicContext } from '@/logic/main/types';

export const setSearchResultsView = async (context: LogicContext) => {
  return {
    updates: [
      {
        type: 'showLayoutComponent',
        data: 'SearchResults',
      },
      {
        type: 'showLayoutComponent',
        data: 'SearchResultsCategory',
      },
      {
        type: 'showLayoutComponent',
        data: 'SearchHeader',
      },
      {
        type: 'hideLayoutComponent',
        data: 'SearchMoreResults',
      },
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.Modal.properties.backButtonVisible',
          value: false,
        },
      },
    ],
  };
};
